import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "relative z-50 w-full h-full",
  "aria-labelledby": "slide-over-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 bg-gray-700 bg-opacity-80 transition-opacity"
}
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_4 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_5 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_6 = { class: "pointer-events-auto relative w-screen max-w-md" }
const _hoisted_7 = { class: "absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl" }
const _hoisted_13 = { class: "flex flex-col gap-4 px-6 sm:px-6" }
const _hoisted_14 = { class: "flex grow flex-col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, "Booking", -1)
const _hoisted_16 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_17 = { class: "relative mt-6 flex-1 bg-white px-4 sm:px-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-primary" }, "Handling")
  ])
], -1)
const _hoisted_19 = { class: "relative my-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "fejning" }, "fejning", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "vask" }, "vask", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "ingen" }, "ingen", -1)
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.7071 7.29289L9.99999 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68341 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z",
      fill: "#6B7280"
    })
  ])
], -1)
const _hoisted_25 = {
  key: 0,
  class: "flex items-center mb-4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-primary" }, "Vask type")
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "relative my-3"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "alm" }, "alm", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "enzym" }, "enzym", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "ren" }, "ren", -1)
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.7071 7.29289L9.99999 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68341 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z",
      fill: "#6B7280"
    })
  ])
], -1)
const _hoisted_34 = { class: "px-2" }
const _hoisted_35 = { class: "py-4" }

import bookingRepository from '@/repositories/bookings/bookingRepository'
import { computed, onMounted, onUnmounted, ref, watch, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'washDetailsComponent',
  props: {
  isVisible: Boolean
},
  setup(__props) {

const store = useStore()
const route = useRoute()
const id = route.params.id

const props = __props

const close = () => {
  store.dispatch('bookingStore/toggleWashOpen')
}

const details = computed(() => store.getters['bookingStore/booking'])

const canWash = computed(() => {
  if (!details.value) {
    return
  }
  const value = details.value.stops.filter(s => s.stopDone === false).length > 0
  return value
})

const description = ref('fejning')
const washType = ref('alm')

const addWash = async () => {
  try {
    const response = await bookingRepository.addWash(id, { bookingId: id, description: description.value, washType: washType.value, time: new Date(), user: '-' })
    if (response.data) {
      store.commit('bookingStore/setWash', response.data)
      store.dispatch('bookingStore/toggleWashOpen')
    }
  } catch (error) {
    console.log('error toggling stop', error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      "enter-active-class": "ease-in-out duration-500",
      "leave-active-class": "ease-in-out duration-500",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide",
      "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                        type: "button",
                        class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      }, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, _toDisplayString(details.value.bookingTitle), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("select", {
                            id: "transport_type",
                            class: "block w-full appearance-none text-sm font-medium rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6",
                            "aria-labelledby": "transport_type",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event))
                          }, _hoisted_23, 512), [
                            [_vModelSelect, description.value]
                          ]),
                          _hoisted_24
                        ]),
                        (description.value === 'vask')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                          : _createCommentVNode("", true),
                        (description.value === 'vask')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _withDirectives(_createElementVNode("select", {
                                id: "transport_type",
                                class: "block w-full appearance-none text-sm font-medium rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6",
                                "aria-labelledby": "transport_type",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((washType).value = $event))
                              }, _hoisted_32, 512), [
                                [_vModelSelect, washType.value]
                              ]),
                              _hoisted_33
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("button", {
                              type: "submit",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (addWash())),
                              class: _normalizeClass(["flex w-full justify-center rounded-md bg-blue-400 px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary", {'opacity-20 pointer-events-none' : canWash.value}])
                            }, " Registrer " + _toDisplayString(description.value), 3)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})